const mobileMenuOpenActionTypes = {
  SET_MOBILE_MENU_OPEN: "SET_MOBILE_MENU_OPEN",
};

export default mobileMenuOpenActionTypes;
